// extracted by mini-css-extract-plugin
export var inner = "Branding-module--inner--38gXt";
export var coolhover = "Branding-module--coolhover--1keLl";
export var brandh = "Branding-module--brandh--1ABP0";
export var brandp = "Branding-module--brandp--3bYpV";
export var brands = "Branding-module--brands--3DpAb";